import { defineRecipe } from "@pandacss/dev";
import buttonBaseStyles from "./utils/buttonBaseStyles";

export const aromaSortButton = defineRecipe({
  className: "aroma-sort-button",
  jsx: ["SortButton"],
  base: {
    ...buttonBaseStyles,
    height: "{sizes.s}",
    width: "{sizes.s}",
    borderRadius: "s",
    paddingX: "10px",
    padding: "padding.1",
    '&[data-state="true"]': {
      bg: "background.neutral.base.subtle",
      _hover: {
        bg: "background.neutral.base.subtle-hover",
        borderColor: "transparent",
      },
    },
    '&[data-state="false"]': {
      bg: "transparent",
      _hover: {
        bg: "background.decorative.neutral.hover-subtle",
        borderColor: "transparent",
      },
    },
  },
});
